import React, { Component } from 'react';
import moment from 'moment';

import GoalsContestsService from '../../services/GoalsContestsService';
import StatisticsManager from '../../managers/StatisticsManager';
import LogoZColor from '../SVG/LogoZColor';
import Trophy from '../SVG/Trophy';

export default class ContestResultItem extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false
        }

        this.statisticsManager = new StatisticsManager();

        this.didGetTicket = this.didGetTicket.bind(this);
        this.didGetTicketPerc = this.didGetTicketPerc.bind(this);

        this.generateRaffleWinner = this.generateRaffleWinner.bind(this);
        this.generateContestWinner = this.generateContestWinner.bind(this);
    }

    componentDidMount() {

    }

    didGetTicket(value, target, isUnder) {

        if (isUnder) {
            return value <= target;
        } else {
            return value >= target;
        }
    }

    didGetTicketPerc(value, lyValue, perc, isUnder) {

        if (isUnder) {
            let target = lyValue * ((100.0 - perc) / 100.0);
            return value <= target;
        } else {
            let target = lyValue * ((100.0 + perc) / 100.0);
            return value >= target;
        }
    }

    generateRaffleWinner() {

        let identity = this.props.identity;

        let self = this;

        let execute = () => {

            self.setState({ isLoading: true }, () => {

                let peopleData = Object.values(identity.blastData.reduce((r, e) => {
                    let key = e.name;
                    if (!r[key]) {
                        r[key] = {
                            name: e.name,
                            kpiOne: e.goalContestReportKpi.reportKpiId === identity.kpiIdOne ?
                                (identity.type === '#' ? self.didGetTicket(e.cyValue, identity.kpiValueOne, identity.kpiUnderOne) : self.didGetTicketPerc(e.cyValue, e.lyValue, identity.kpiValueOne, identity.kpiUnderOne))
                                : null,
                            kpiTwo: e.goalContestReportKpi.reportKpiId === identity.kpiIdTwo ?
                                (identity.type === '#' ? self.didGetTicket(e.cyValue, identity.kpiValueTwo, identity.kpiUnderTwo) : self.didGetTicketPerc(e.cyValue, e.lyValue, identity.kpiValueTwo, identity.kpiUnderTwo))
                                : null,
                            kpiThree: e.goalContestReportKpi.reportKpiId === identity.kpiIdThree ?
                                (identity.type === '#' ? self.didGetTicket(e.cyValue, identity.kpiValueThree, identity.kpiUnderThree) : self.didGetTicketPerc(e.cyValue, e.lyValue, identity.kpiValueThree, identity.kpiUnderThree))
                                : null,
                            kpiMinOne: e.goalContestReportKpi.reportKpiId === identity.kpiIdMinOne ? self.didGetTicket(e.cyValue, identity.kpiValueMinOne, identity.kpiUnderMinOne) : null,
                            kpiMinTwo: e.goalContestReportKpi.reportKpiId === identity.kpiIdMinTwo ? self.didGetTicket(e.cyValue, identity.kpiValueMinTwo, identity.kpiUnderMinTwo) : null,
                            kpiMinThree: e.goalContestReportKpi.reportKpiId === identity.kpiIdMinThree ? self.didGetTicket(e.cyValue, identity.kpiValueMinThree, identity.kpiUnderMinThree) : null
                        }
                    } else {
                        if (e.goalContestReportKpi.reportKpiId === identity.kpiIdOne && identity.kpiIdOne != null) {
                            r[key].kpiOne = (identity.type === '#' ? self.didGetTicket(e.cyValue, identity.kpiValueOne, identity.kpiUnderOne) : self.didGetTicketPerc(e.cyValue, e.lyValue, identity.kpiValueOne, identity.kpiUnderOne));
                        } else if (e.goalContestReportKpi.reportKpiId === identity.kpiIdTwo && identity.kpiIdTwo != null) {
                            r[key].kpiTwo = (identity.type === '#' ? self.didGetTicket(e.cyValue, identity.kpiValueTwo, identity.kpiUnderTwo) : self.didGetTicketPerc(e.cyValue, e.lyValue, identity.kpiValueTwo, identity.kpiUnderTwo));
                        } else if (e.goalContestReportKpi.reportKpiId === identity.kpiIdThree && identity.kpiIdThree != null) {
                            r[key].kpiThree = (identity.type === '#' ? self.didGetTicket(e.cyValue, identity.kpiValueThree, identity.kpiUnderThree) : self.didGetTicketPerc(e.cyValue, e.lyValue, identity.kpiValueThree, identity.kpiUnderThree));
                        }

                        if (e.goalContestReportKpi.reportKpiId === identity.kpiIdMinOne && identity.kpiIdMinOne != null) {
                            r[key].kpiMinOne = self.didGetTicket(e.cyValue, identity.kpiValueMinOne, identity.kpiUnderMinOne);
                        } else if (e.goalContestReportKpi.reportKpiId === identity.kpiIdMinTwo && identity.kpiIdMinTwo != null) {
                            r[key].kpiMinTwo = self.didGetTicket(e.cyValue, identity.kpiValueMinTwo, identity.kpiUnderMinTwo);
                        } else if (e.goalContestReportKpi.reportKpiId === identity.kpiIdMinThree && identity.kpiIdMinThree != null) {
                            r[key].kpiMinThree = self.didGetTicket(e.cyValue, identity.kpiValueMinThree, identity.kpiUnderMinThree);
                        }
                    }

                    return r;
                }, {}));

                let ticketPot = [];
                for (var i = 0; i < peopleData.length; i++) {
                    if ((peopleData[i].kpiMinOne || peopleData[i].kpiMinOne === null) && (peopleData[i].kpiMinTwo || peopleData[i].kpiMinTwo === null) && (peopleData[i].kpiMinThree || peopleData[i].kpiMinThree === null)) {
                        if (identity.contestType === 'Raffle (Each)') {
                            if (peopleData[i].kpiOne) {
                                ticketPot.push(peopleData[i].name)
                            }
                            if (peopleData[i].kpiTwo) {
                                ticketPot.push(peopleData[i].name)
                            }
                            if (peopleData[i].kpiThree) {
                                ticketPot.push(peopleData[i].name)
                            }
                        } else {
                            if (peopleData[i].kpiOne && (peopleData[i].kpiTwo || peopleData[i].kpiTwo === null) && (peopleData[i].kpiThree || peopleData[i].kpiThree === null)) {
                                ticketPot.push(peopleData[i].name)
                            }
                        }
                    }
                }

                identity.winnerName = ticketPot.length === 0 ? null : _.shuffle(ticketPot)[0];
                let winnerTicketCount = 0;
                for (var i = 0; i < ticketPot.length; i++) {
                    if (ticketPot[i] === identity.winnerName) {
                        winnerTicketCount++;
                    }
                }
                identity.finalTicketCount = winnerTicketCount;

                self.props.saveContestResult(identity, () => {
                    self.setState({ isLoading: false });
                });
            });
        };

        if (identity.contestResultId != null) {
            zconfirm("A winner has already been chosen for this period. Would you like to pick a new winner?", execute);
        }
        else {
            execute();
        }
    }

    generateContestWinner() {
        let identity = this.props.identity;

        let self = this;

        let execute = () => {

            self.setState({ isLoading: true }, () => {

                let peopleData = Object.values(identity.blastData.reduce((r, e) => {
                    let key = e.name;
                    if (!r[key]) {
                        r[key] = {
                            name: e.name,
                            kpiOne: e.goalContestReportKpi.reportKpiId === identity.kpiIdOne ? e.cyValue : null,
                            kpiTwo: e.goalContestReportKpi.reportKpiId === identity.kpiIdTwo ? e.cyValue : null,
                            kpiThree: e.goalContestReportKpi.reportKpiId === identity.kpiIdThree ? e.cyValue : null,
                            kpiMinOne: e.goalContestReportKpi.reportKpiId === identity.kpiIdMinOne ? self.didGetTicket(e.cyValue, identity.kpiValueMinOne, identity.kpiUnderMinOne) : null,
                            kpiMinTwo: e.goalContestReportKpi.reportKpiId === identity.kpiIdMinTwo ? self.didGetTicket(e.cyValue, identity.kpiValueMinTwo, identity.kpiUnderMinTwo) : null,
                            kpiMinThree: e.goalContestReportKpi.reportKpiId === identity.kpiIdMinThree ? self.didGetTicket(e.cyValue, identity.kpiValueMinThree, identity.kpiUnderMinThree) : null
                        }
                    } else {
                        if (e.goalContestReportKpi.reportKpiId === identity.kpiIdOne && identity.kpiIdOne != null) {
                            r[key].kpiOne = e.cyValue;
                        } else if (e.goalContestReportKpi.reportKpiId === identity.kpiIdTwo && identity.kpiIdTwo != null) {
                            r[key].kpiTwo = e.cyValue;
                        } else if (e.goalContestReportKpi.reportKpiId === identity.kpiIdThree && identity.kpiIdThree != null) {
                            r[key].kpiThree = e.cyValue;
                        }

                        if (e.goalContestReportKpi.reportKpiId === identity.kpiIdMinOne && identity.kpiIdMinOne != null) {
                            r[key].kpiMinOne = self.didGetTicket(e.cyValue, identity.kpiValueMinOne, identity.kpiUnderMinOne);
                        } else if (e.goalContestReportKpi.reportKpiId === identity.kpiIdMinTwo && identity.kpiIdMinTwo != null) {
                            r[key].kpiMinTwo = self.didGetTicket(e.cyValue, identity.kpiValueMinTwo, identity.kpiUnderMinTwo);
                        } else if (e.goalContestReportKpi.reportKpiId === identity.kpiIdMinThree && identity.kpiIdMinThree != null) {
                            r[key].kpiMinThree = self.didGetTicket(e.cyValue, identity.kpiValueMinThree, identity.kpiUnderMinThree);
                        }
                    }

                    return r;
                }, {}));

                let tmp1 = null, tmp2 = null, tmp3 = null;
                for (var i = 0; i < peopleData.length; i++) {
                    if ((peopleData[i].kpiMinOne || peopleData[i].kpiMinOne === null) && (peopleData[i].kpiMinTwo || peopleData[i].kpiMinTwo === null) && (peopleData[i].kpiMinThree || peopleData[i].kpiMinThree === null)) {
                        if (peopleData[i].kpiOne != null) {
                            if (tmp1 === null) {
                                tmp1 = [];
                            }
                            tmp1.push({ key: peopleData[i].name, value: peopleData[i].kpiOne });
                        }
                        if (peopleData[i].kpiTwo != null) {
                            if (tmp2 === null) {
                                tmp2 = [];
                            }
                            tmp2.push({ key: peopleData[i].name, value: peopleData[i].kpiTwo });
                        }
                        if (peopleData[i].kpiThree != null) {
                            if (tmp3 === null) {
                                tmp3 = [];
                            }
                            tmp3.push({ key: peopleData[i].name, value: peopleData[i].kpiThree });
                        }
                    }
                }

                let resultSets = {
                    r1: self.statisticsManager.calculateModZScore(tmp1, undefined, identity.kpiUnderOne),
                    r2: self.statisticsManager.calculateModZScore(tmp2, undefined, identity.kpiUnderTwo),
                    r3: self.statisticsManager.calculateModZScore(tmp3, undefined, identity.kpiUnderThree)
                }

                if (resultSets.r2 === null && resultSets.r3 === null) {

                    if (resultSets.r1.length > 0) {
                        identity.winnerName = resultSets.r1[resultSets.r1.length - 1].key;
                    }
                    if (resultSets.r1.length > 1) {
                        identity.secondName = resultSets.r1[resultSets.r1.length - 2].key;
                    }
                    if (resultSets.r1.length > 2) {
                        identity.thirdName = resultSets.r1[resultSets.r1.length - 3].key;
                    }
                } else {
                    let tempResults = [];
                    if (resultSets.r1 != null) {
                        tempResults = tempResults.concat(resultSets.r1);
                    }
                    if (resultSets.r2 != null) {
                        tempResults = tempResults.concat(resultSets.r2);
                    }
                    if (resultSets.r3 != null) {
                        tempResults = tempResults.concat(resultSets.r3);
                    }

                    tempResults = _.sortBy(Object.values(tempResults.reduce((r, e) => {
                        let key = e.key;
                        if (!r[key]) {
                            r[key] = e;
                        } else {
                            r[key].value += e.value;
                        }
                        return r;
                    }, {})), (obj) => { return obj.value });

                    if (tempResults.length > 0) {
                        identity.winnerName = tempResults[tempResults.length - 1].key;
                    }
                    if (tempResults.length > 1) {
                        identity.secondName = tempResults[tempResults.length - 2].key;
                    }
                    if (tempResults.length > 2) {
                        identity.thirdName = tempResults[tempResults.length - 3].key;
                    }
                }

                // self.setState({ isLoading: false }); //temp

                self.props.saveContestResult(identity, () => {
                    self.setState({ isLoading: false });
                });
            });
        };

        if (identity.contestResultId != null) {
            zconfirm("A winner has already been chosen for this period. Would you like to pick a new winner?", execute);
        }
        else {
            execute();
        }
    }


    render() {

        let identity = this.props.identity;

        let mainJsx = null;

        if (this.props.isCompetition) {

            if (identity.contestResultId === null) {

                let loadingClass = this.state.isLoading ? 'raffle-loading raffle-loading--active' : 'raffle-loading';

                mainJsx = (
                    <div className="main-raffle-outer">
                        <div className="raffle-icon-container">
                            <div className="raffle-icon" style={{ backgroundColor: '#fe0101' }}></div>
                        </div>
                        <div className="raffle-text">
                            <div className="raffle-text-top">No Winner</div>
                            <div className="raffle-text-bottom">{
                                moment(identity.calStart.substring(0, identity.calStart.length - 1)).format("MM/DD/YYYY") + ' - ' + moment(identity.calEnd.substring(0, identity.calEnd.length - 1)).format("MM/DD/YYYY")
                            }</div>
                        </div>
                        <div className="raffle-winner-button" onClick={this.generateContestWinner}>Finish</div>
                        <div className={loadingClass}>
                            <LogoZColor className="loading-z-color" />
                        </div>
                    </div>
                );
            } else {

                let loadingClass = this.state.isLoading ? 'raffle-loading raffle-loading--active' : 'raffle-loading';

                mainJsx = (

                    <div className="main-competition-outer">
                        <div className="competition-winner-trophy-container">
                            <Trophy className="trophy-gold" />

                        </div>
                        <div className="competition-winner-text-container">
                            <div className="competition-winner-text-top">{identity.winnerName}</div>
                            <div className="competition-winner-text-bottom">{
                                moment(identity.calStart.substring(0, identity.calStart.length - 1)).format("MM/DD/YYYY") + ' - ' + moment(identity.calEnd.substring(0, identity.calEnd.length - 1)).format("MM/DD/YYYY")
                            }</div>
                        </div>
                        <div className="competition-winner-button" onClick={this.generateContestWinner}>Retry</div>
                        <div className="competition-notwinner">
                            <div className="competition-notwinner-trophy">
                                <Trophy className="trophy-silver" />
                            </div>
                            <div className="competition-notwinner-text">{identity.secondName}</div>
                        </div>
                        <div className="competition-notwinner">
                            <div className="competition-notwinner-trophy">
                                <Trophy className="trophy-bronze" />
                            </div>
                            <div className="competition-notwinner-text">{identity.thirdName}</div>
                        </div>
                        <div className={loadingClass}>
                            <LogoZColor className="loading-z-color" />
                        </div>
                    </div>
                );
            }

        } else {
            let dotStyle = { backgroundColor: identity.contestResultId === null ? '#fe0101' : 'rgba(0, 126, 181, 1)' }
            let raffleText = identity.contestResultId === null ? 'No Winner' : identity.winnerName;
            let raffleButtonText = identity.contestResultId === null ? 'Finish' : 'Retry';

            let loadingClass = this.state.isLoading ? 'raffle-loading raffle-loading--active' : 'raffle-loading';

            mainJsx = (
                <div className="main-raffle-outer">
                    <div className="raffle-icon-container">
                        <div className="raffle-icon" style={dotStyle}></div>
                    </div>
                    <div className="raffle-text">
                        <div className="raffle-text-top">{raffleText}</div>
                        <div className="raffle-text-bottom">{
                            moment(identity.calStart.substring(0, identity.calStart.length - 1)).format("MM/DD/YYYY") + ' - ' + moment(identity.calEnd.substring(0, identity.calEnd.length - 1)).format("MM/DD/YYYY")
                        }</div>
                    </div>
                    <div className="raffle-winner-button" onClick={this.generateRaffleWinner}>{raffleButtonText}</div>
                    <div className={loadingClass}>
                        <LogoZColor className="loading-z-color" />
                    </div>
                </div>
            );
        }

        return mainJsx;
    }
}